import { search } from "fast-fuzzy";
import { useMemo, useState } from "react";
import { connect } from "react-redux";
import { LocationCard } from "../../Components/Card/Card";
import {
  NoResultsFallback,
  ZeroStateFallback
} from "../../Components/FallBacks/FallBacks";
import Header from "../../Components/Header/Header";
import SearchBox from "../../Components/SearchBox/SearchBox";
import { setSelectedLocation } from "../../Redux/locations/action";
import { isValidArray } from "../../Services/validators";

function LocationSearch(props) {
  const [searchKey, setSearchKey] = useState("");
  const results = useMemo(() => {
    if (isValidArray(props.locations)) {
      if (!searchKey) {
        return props.locations;
      }
      return search(searchKey, props.locations, {
        keySelector: (item) => `${item.location} ${item.PCTNo}`,
        threshold: 0.7
      });
    }
  }, [searchKey, props.locations]);
  return (
    <div className="inherit-parent-height inherit-parent-width overflow-hidden">
      <Header
        theme={props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light"}
        title={
          window.location.pathname.includes("faceIdentification")
            ? "Face Identification"
            : window.location.pathname.includes("complaints")
            ? "Complaint"
            : "Procedure"
        }
        backOnClick={() => {
          if (window.location.pathname.includes("faceIdentification")) {
            props.navigate("/faceIdentification/lastCapturedAttendance");
          } else if (window.location.pathname.includes("complaints")) {
            props.navigate("/complaints/create");
          } else {
            props.navigate("/");
          }
        }}
        profileOnClick={() => {
          props.navigate("/settings");
        }}
      />

      <div className="inherit-parent-width remaining-body-height flex-justify-content-center">
        <div className="inherit-parent-height inherit-parent-width max-width-767px overflow-hidden">
          <>
            <div className="font-color-tertiaryColor5 text-align-center padding-large">
              SELECT A LOCATION TO CONTINUE
            </div>
            <SearchBox
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              data-cy={
                searchKey?.length > 0 ? "search-clear-button" : "search-button"
              }
              placeholder="Search by location or PCT"
            />
          </>

          {!isValidArray(props.locations) && (
            <div className="inherit-parent-width padding-left-large padding-right-large">
              {Array.from({ length: 20 }).map((_, index) => (
                <div
                  key={index}
                  className="shimmer padding-larger inherit-parent-width margin-bottom-large"
                />
              ))}
            </div>
          )}

          {!props.loading &&
            isValidArray(props.locations) &&
            isValidArray(results) && (
              <div className="inherit-parent-width inherit-parent-height overflow-x-scroll hide-scrollbar">
                <div
                  className="padding-left-large padding-right-large padding-bottom-large inherit-parent-width inherit-parent-height"
                  data-cy="locations-list"
                >
                  {results &&
                    results.map((data, index) => (
                      <div className="inherit-parent-width" key={index}>
                        <LocationCard
                          onClick={() => {
                            props.setSelectedLocation(data.documentId);
                            if (
                              window.location.pathname.includes(
                                "faceIdentification"
                              )
                            ) {
                              props.navigate(
                                "/faceIdentification/captureImage"
                              );
                            } else if (
                              window.location.pathname.includes("complaints")
                            ) {
                              props.navigate("/complaints/create");
                            } else {
                              props.navigate(`/${data.documentId}/procedures`);
                            }
                          }}
                          index={index}
                          data={data}
                          locations={props.locations?.data}
                          loading={props.locations.loading}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}

          {!props.loading &&
            !searchKey &&
            isValidArray(props.locations) &&
            !isValidArray(results) && (
              <div
                style={{
                  height: "calc(100% - 120px)"
                }}
              >
                <ZeroStateFallback
                  title="No connected locations"
                  description="There are no location assigned to your account."
                  type="LOCATION"
                />
              </div>
            )}

          {!props.loading &&
            searchKey &&
            isValidArray(props.locations) &&
            !isValidArray(results) && (
              <NoResultsFallback
                type="LOCATION"
                resetOnClick={() => {
                  setSearchKey("");
                }}
              />
            )}

          {props.loading && <Suspense />}
        </div>
      </div>
    </div>
  );
}

const Suspense = () => {
  return (
    <div className="inherit-parent-width padding-top-large">
      {[...Array(7)].map((_data, index) => (
        <div className="inherit-parent-width" key={index}>
          <div className="shimmer padding-larger inherit-parent-width" />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    complaints: state.complaints
  };
};
const mapDispatchToProps = function () {
  return {
    setSelectedLocation: (locationId) => setSelectedLocation(locationId)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSearch);
